import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const Referearnadmin = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/referandearn');
     console.log(res);
     setCategories(res.data.result);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const handlestatuschange=async(id,status)=>{
   try{
    const res=await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/referandearn/${id}`,{
       status
    });
    alert('Status updated');
    fetchcategories();
   }catch(e){
    setError(e.response?.data?.message || 'Save failed');
   }
   }
 
   // backend supports delete using PUT /referandearn/:id
   const handledelete=async(id)=>{
     setLoading(true);
     try{
       await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/referandearn/${id}`,{});
       fetchcategories();
     }catch(e){
       setError(e.response?.data?.message || 'Save failed');
     }finally{
       setLoading(false);
     }
   }


 

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">References</h3>
         
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Phone Number</th>
                <th>Status</th>
               
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.refer}</td>
                  <td><select className="form-control" value={item.status} onChange={(e)=>handlestatuschange(item.id,e.target.value)}>
                    <option value="wrong_number">Wrong Number</option>
                     <option value="accepted">Accepted</option>
                      <option value="not_accepted">Not accepted</option>
                       <option value="pending">Pending</option>
                     <option value="follow_up">Follow Up</option>
                    <option value="need_to_call_again">Need To Call Again</option>
                    </select></td>
                  
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="8" className="text-center text-muted">
                  No Company Data Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
    

    </>
  );
};
export default Referearnadmin;

